export const h = {
    "common": {
        "webSuffix": "-QIDI Tech起迪科技",
        "email": "メールボックス",
        "password": "パスワード",
        "verificationCode": "認証コード",
        "username": "ユーザー名",
        "readAndAgree": "同意します",
        "and": "と",
        "userAgreement": "ユーザプロトコル",
        "privacyPolicy": "プライバシーポリシー",
        "copy": "著作権所有© 2025件のディ保有所有権",
        "sendVerificationCode": "認証コードの送信",
        "Sending": "送信中",
        "tryAgainInSeconds": "秒後に再試行",
        "userNameRequired": "ユーザー名を入力してください",
        "passwordInputLabel": "パスワードを入力してください",
        "checkPasswordInputLabel": "確認パスワードを入力してください",
        "userEmailRequired": "メールアドレスを入力してください",
        "userEmailInvalid": "正しいメールアドレスを入力してください",
        "emailCodeRequired": "認証コードを入力してください",
        "newPasswordInputLabel": "新しいパスワードを入力してください",
        "confirmPasswordInputLabel": "パスワードを再入力してください",
        "passwordMismatchErrorLabel": "2回の入力パスワードが一致しません",
        "agreementRequired": "契約書を読んで同意してください",
        "tip": "ヒント",
        "tipAlreadyLogin": "ログインが検出され、ユーザーセンターにジャンプします",
        "tipWelcomeBack": "お帰りなさい~",
        "tipDeleteAccountFail": "アカウントの削除に失敗しました。アカウントインタフェースを削除して一時停止中です",
        "pleaseAgreeFirst": "まず同意してください",
        "agree": "に同意",
        "refuse": "拒否",
        "tipNeedLogin": "先にログインしてください",
        "tipChangePasswordSuccess": "パスワードの変更に成功しました。ログインページにジャンプします",
        "tipGetUserInfoSuccess": "情報の取得に成功しました",
        "tipGetUserInfoFail": "情報の取得に失敗しました",
        "tipLoginOut": "ログオンの終了",
        "delete": "削除＃サクジョ＃",
        "back": "リターンマッチ",
        "init": "初期化",

        "passwordInputLengthErrorLabel": "パスワードの長さは6～20です。",
        "changePasswordFail": "元のパスワードが正しくありません",
        "tipDeleteAccountSuccess": "アカウントの削除に成功しました",
        "emailCodeSentSuccess": "認証コードが発行されました",
        "emailCodeSentFail": "認証コードの発行に失敗しました",
        "emailLoginFail": "認証コードが期限切れです",
        "passwordLoginFail": "ログインパスワードエラー",
        "editUserInfoSuccess": "ユーザー情報の変更に成功しました",
        "registerSuccess": "登録に成功しました",
        "registerFail": "登録に失敗しました",
        "registerEmailExistFail": "メールボックスは既に存在します",

        "resMessageTip0": "不明な情報",
        "resMessageTip1": "パスワードエラー",
        "resMessageTip2": "パスワードの長さは6～20です。",
        "resMessageTip3": "アカウントエラー",
        "resMessageTip4": "認証コードが発行されました",
        "resMessageTip5": "認証コードの発行に失敗しました",
        "resMessageTip6": "認証コードが期限切れです",
        "resMessageTip7": "パスワードエラー",
        "resMessageTip8": "パスワードは旧パスワードと同じにすることはできません",
        "resMessageTip9": "メールボックスは既に存在します",
        "resMessageTip10": "登録に成功しました",
        "resMessageTip11": "登録に失敗しました",
        "resMessageTip12": "ユーザー情報の変更に成功しました",
        "resMessageTip13": "ユーザー情報の変更に失敗しました",
        "resMessageTip14": "取得に成功しました",
        "resMessageTip15": "取得に失敗しました",
        "resMessageTip16": "パスワードの変更に成功しました",
        "resMessageTip17": "パスワードの変更に失敗しました",
        "resMessageTip18": "パスワードのリセットに成功しました",
        "resMessageTip19": "パスワードのリセットに失敗しました",
        "resMessageTip20": "ログイン成功",
        "resMessageTip21": "ログインに失敗しました",
        "resMessageTip22": "アカウントの削除に成功しました",
        "resMessageTip23": "アカウントの削除に失敗しました",
        "resMessageTip24": "認証コードに誤りがある",
        "noUserInfoError": "ネットワークエラー、再ログインしてください"
    },
    "changePassword": {
        "newPassword": "新しいパスワード"
    },
    "deleteUser": {
        "tipDeleteUser": "残念ながらあなたは離れます。アカウントが削除されると、すべての個人データは永久に消失し、復元できません。",
        "accountDeletionTerms": "アカウント削除条件"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "メールボックスからパスワードを取り戻す",
        "confirmPassword": "パスワードの確認",
        "resettingPassword": "パスワードをリセット",
        "resetting": "リセット"
    },
    "login": {
        "passwordLogin": "パスワードログイン",
        "verifyLogin": "ログインの検証",
        "accountRegistration": "アカウント登録",
        "forgotPassword": "パスワードを忘れる",
        "login": "ログイン＃ログイン＃",
        "localLogin": "ローカルログイン",
        "loginOut": "ログアウト",
        "continueOnYourWay": "行き続ける"
    },
    "register": {
        "registerAnAccount": "アカウントの登録",
        "register": "登録"
    },
    "userCenter": {
        "personalInformation": "個人情報",
        "modifyInformation": "情報の変更",
        "changePassword": "パスワードの変更",
        "cancelAccount": "アカウントの登録解除",
        "exitAccount": "アカウントを終了する",
        "change": "変更",
        "maxCharLimitTip": "ユーザー名の長さは10文字以内",
    },
    "policies": {
        "deleteAccountPrivacy": "アカウントプロトコルの削除",
        "agreement": "プロトコルの使用方法",
        "privacyPolicy": "プライバシーポリシー"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "あなたの国または地域を選択",
        "recommendedVisits": "推奨アクセス",
        "NorthAmerica": "北アメリカ",
        "Europe": "ヨーロッパ",
        "Asia": "アジア",
        "Other": "その他",
    }
}
export const aAndL ={
    "ar": {
        "Country": "アラビア",
        "Language": "アラビア語"
    },
    "cs": {
        "Country": "チェコ.",
        "Language": "チェコ語"
    },
    "de": {
        "Country": "ドイツ.",
        "Language": "ドイツ語"
    },
    "en": {
        "Country": "英国",
        "Language": "英語"
    },
    "es": {
        "Country": "スペイン.",
        "Language": "スペイン語"
    },
    "fr": {
        "Country": "フランス.",
        "Language": "フランス語"
    },
    "he": {
        "Country": "イスラエル.",
        "Language": "ヘブライ語"
    },
    "hu": {
        "Country": "ハンガリー.",
        "Language": "ハンガリー語"
    },
    "it": {
        "Country": "イタリア.",
        "Language": "イタリア語"
    },
    "ja": {
        "Country": "日本",
        "Language": "日本語"
    },
    "ko": {
        "Country": "韓国",
        "Language": "韓国語"
    },
    "nl": {
        "Country": "オランダ.",
        "Language": "オランダ語"
    },
    "pt": {
        "Country": "ポルトガル.",
        "Language": "ポルトガル語"
    },
    "pt_BR": {
        "Country": "ポルトガル（ブラジル）",
        "Language": "ポルトガル語（ブラジル）"
    },
    "ru": {
        "Country": "ロシア.",
        "Language": "ロシア語"
    },
    "sv": {
        "Country": "スウェーデン.",
        "Language": "スウェーデン語"
    },
    "tr": {
        "Country": "トルコ.",
        "Language": "トルコ語"
    },
    "uk": {
        "Country": "ウクライナ.",
        "Language": "ウクライナ語"
    },
    "zh": {
        "Country": "中国大陸",
        "Language": "簡体字中国語"
    },
    "zh_tw": {
        "Country": "台湾",
        "Language": "繁体字中国語"
    },
    "Canada": {
        "Country": "カナダ.",
        "Language": "英語"
    },
    "United_States": {
        "Country": "アメリカ",
        "Language": "英語"
    },
    "United_Kingdom": {
        "Country": "英国",
        "Language": "英語"
    },
    "EU_Countries": {
        "Country": "EU諸国",
        "Language": "英語"
    },
    "Australia": {
        "Country": "オーストラリア",
        "Language": "英語"
    },
    "globalzh": {
        "Country": "グローバル",
        "Language": "簡体字中国語"
    },
    "globalen": {
        "Country": "Global",
        "Language": "英語"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/ja.js